import { require200Status } from "../../utils/response.js";
import "../../../constants/index.js";
import { transformWithSpec } from "../../../utils/response.js";
import { API_HEADERS } from "../../../constants/api-client.js";
import { ProfileResponseConvertSpecs } from "../../../types/models/profile.specs.js";
function selfEndpoints(builder) {
  return {
    getProfile: builder.query({
      providesTags: ["self"],
      query: () => ({
        url: "self/profile",
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec(ProfileResponseConvertSpecs)
    }),
    getProfileWithToken: builder.query({
      providesTags: ["self"],
      query: (token) => ({
        url: "self/profile",
        validateStatus: require200Status,
        headers: {
          [API_HEADERS.AUTHORIZATION]: `Bearer ${token}`
        }
      }),
      transformResponse: transformWithSpec(ProfileResponseConvertSpecs)
    })
  };
}
export {
  selfEndpoints as default
};
